export const SURVEY_STEPS = {
  GAME: 1,
  RESULT: 2,
};

export const ERROR_RESPONSE_TYPES = {
  SURVEY_ALREADY_PLAYED: 'SURVEY_ALREADY_PLAYED',
};
